import React, { ComponentProps } from "react";
import styled from "styled-components";
import ClassicRefreshSpinner from "common/Lists/ClassicRefreshSpinner";
import NewLookRefreshSpinner from "common/Lists/NewLookRefreshSpinner";
import { RefreshSpinnerProps as NewLookRefreshSpinnerProps } from "common/Scroll/pullToRefresh";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

type RefreshSpinnerProps =
  | ({ look: "classic" } & ComponentProps<typeof ClassicRefreshSpinner>)
  | ({ look: "newLook" } & NewLookRefreshSpinnerProps);

const RefreshSpinner = (props: RefreshSpinnerProps) =>
  props.look === "classic" ? (
    <ClassicRefreshSpinner {...props} />
  ) : (
    <NewLookRefresh {...props} />
  );

export default React.memo(RefreshSpinner);

const NewLookRefresh = (props: NewLookRefreshSpinnerProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  return (
    <>
      <NewLookRefreshSpinner {...props} />
      <LiveStatus role="status">
        {props.isRefreshing ? t("labels.refreshing") : ""}
      </LiveStatus>
    </>
  );
};

const LiveStatus = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
